import React, { useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "../api";
import { useLang } from "../i18n";

export const VERIF_STATUSES = ["negativo", "falso_positivo", "en_revision", "positivo_confirmado"];

export default function VerifEditor({ endpoint, doc, onSaved, testid }) {
  const { t } = useLang();
  const [status, setStatus] = useState(doc?.verif_status || (doc?.result === "match" ? "en_revision" : "negativo"));
  const [notes, setNotes] = useState(doc?.verif_notes || "");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      await api.patch(endpoint, { verif_status: status, verif_notes: notes });
      toast.success(t("vs.saved"));
      onSaved?.({ verif_status: status, verif_notes: notes });
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ec-card p-4 space-y-3" data-testid={`${testid}-verif-editor`}>
      <div className="grid sm:grid-cols-[280px_1fr] gap-3 items-start">
        <div>
          <label className="ec-label">{t("vs.label")}</label>
          <select className="ec-input" value={status} onChange={(e) => setStatus(e.target.value)} data-testid={`${testid}-verif-status`}>
            {VERIF_STATUSES.map((s) => <option key={s} value={s}>{t(`vs.${s}`)}</option>)}
          </select>
          <p className="text-[11px] text-slate-400 mt-1" data-testid={`${testid}-verif-desc`}>{t(`vs.d_${status}`)}</p>
        </div>
        <div>
          <label className="ec-label">{t("vs.notes")}</label>
          <textarea className="ec-input" rows={2} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder={t("vs.notes_ph")} data-testid={`${testid}-verif-notes`} />
        </div>
      </div>
      <div className="flex justify-end">
        <button onClick={save} disabled={busy} data-testid={`${testid}-verif-save`} className="flex items-center gap-1.5 px-4 py-2 rounded-lg bg-[#16335F] text-white text-xs font-bold hover:bg-[#033A8C] disabled:opacity-60">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Save className="w-3.5 h-3.5" />} {t("common.save")}
        </button>
      </div>
    </div>
  );
}
